export const data = [
    {
        id: "0",
        question: "'Keep It Simple Silly (KISS)' says:",
        answer: "Design robots with fewer complicated, moving parts.",
        variants: [`Effective communication is important`, `Use simpler terminology when teaching others.`, `Practice brevity when in an emergency`, `Design robots with fewer complicated, moving parts.`]
    },
    {
        id: "1",
        question: "'Consistency is Key' means:",
        answer: "Make sure that your robot completes its tasks well consistently.",
        variants: [`Prioritize points over all else.`, `Make sure that your team members are showing up to meetings consistently.`, `Try and build the most complicated robot.`, `Make sure that your robot completes its tasks well consistently.`]
    },
    {
        id: "2",
        question: "'Touch it, own it' is a phrase centered around:",
        answer: "Designing game piece pickup mechanisms.",
        variants: [`Borrowing other clubs' tools.`, `Designing game piece pickup mechanisms.`, `Other teammates' lunches.`, `Motivating robot drivers and operators.`]
    },
    {
        id: "3",
        question: "'Keeping your CG low' has what benefits?",
        answer: "Easier to drive and less susceptible to tipping over.",
        variants: [`Easier to drive and less susceptible to tipping over.`, `Preventing your robot from spontaneously combusting`, `Testing the drivetrain`, `The robot can be equipped with heavier wheel rims.`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },